interface Props {
  label?: string;
  id?: string;
  value?: any;
}

export const TextItem = (props: Props) => {
  return (
    <>
      <div className="row">
        {props.label && (
          <label htmlFor={props.id} className="fw-bold col-sm-3 col-form-label zvlabel">
            {props.label}
          </label>
        )}

        <div className="col-sm-9">
          <span>{props.value}</span>
        </div>
      </div>
    </>
  );
};
